export const parseToSlug = (string) => {
  return string.toLowerCase().replace(/\s+/g, "-")
}
